/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import DS from 'ember-data';
import { reject } from 'rsvp';
import { dropTask } from 'ember-concurrency';
import GroupCondition from 'cio/app-models/conditions/group';
import serialize from 'cio/utils/conditions/serialize';
import AuthService from 'cio/services/auth';

interface CampaignsTriggerSetupNewSegmentBuilderArgs {
  onCreate: (_: any) => unknown;
  onCancel: () => unknown;
}

export default class CampaignsTriggerSetupNewSegmentBuilder extends Component<CampaignsTriggerSetupNewSegmentBuilderArgs> {
  'data-test-condition-list-create-segment' = true;

  @service store!: DS.Store;
  @service auth!: AuthService;

  @tracked name = '';
  @tracked conditionTree = GroupCondition.create();

  get disabled() {
    let saveSegmentTask = this.saveSegment;
    return saveSegmentTask.isRunning || this.conditionTree.hasErrors || !isEmpty(this.errorMessage);
  }

  get errorMessage() {
    if (isEmpty(this.name.trim())) {
      return 'Please enter a name for the segment.';
    }

    if (isEmpty(this.conditionTree.children)) {
      return 'Please add some conditions for this segment.';
    }

    if (this.conditionTree.get('hasErrors')) {
      return 'Please fix the errors marked above.';
    }

    return null;
  }

  saveSegment = dropTask(async (ev: KeyboardEvent) => {
    ev.preventDefault();

    if (!this.conditionTree.validate()) {
      return reject();
    }

    let segment = this.store.createRecord('segment', {
      name: this.name,
      conditions: serialize(this.conditionTree),
    });

    await segment.save();
    return this.args.onCreate(segment);
  });
}
